// src/pages/TestView.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";

export default function TestView() {
  const { id } = useParams();
  const [test, setTest] = useState(null);

  /* i18n */
  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (k, d = "") => translations[k] || d;

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/tests/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setTest(data);
      } catch (err) {
        console.error("Test getirilemedi:", err);
      }
    })();
  }, [id]);

  if (!test) return <p className="text-center my-5">Yükleniyor…</p>;

  // Kategori tipi için label üret
  const categoryLabel = !test.has_category
    ? t("NO_CATEGORY", "Kategori yok")
    : test.multiple_category
      ? t("MULTIPLE_CATEGORY", "Çoklu seçim")
      : t("SINGLE_CATEGORY", "Tekli seçim");

  return (
    <div className="container my-4">
      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between">
          <h5 className="mb-0">{t("TEST_DETAILS", "Test Detayları")}</h5>
          <Link to={`/test/edit/${id}`} className="btn btn-sm btn-outline-primary">
            {t("EDIT", "Düzenle")}
          </Link>
        </div>
        <div className="card-body">
          <p>
            <strong>{t("TABLE_TEST_NAME", "Test Adı")}:</strong> {test.name}
          </p>
          {/* Test Türleri */}
<p>
  <strong>{t("TEST_TYPES", "Test Türleri")}:</strong>{" "}
  {(() => {
    const types = Array.isArray(test.test_types)
      ? test.test_types
      : Array.isArray(test.TestTypes)
        ? test.TestTypes
        : [];

    if (types.length === 0) {
      return t("NO_TYPES", "Tanımlı tür yok");
    }
    // İstersen badge gibi göstermek yerine virgülle birleştir
    return types.map(tt => tt?.name).filter(Boolean).join(", ");
  })()}
</p>

          <p>
            <strong>{t("TABLE_MAX_SCORE", "Maks. Puan")}:</strong> {test.max_score}
          </p>
          <p>
            <strong>{t("TABLE_DATE", "Oluşturma Tarihi")}:</strong>{" "}
            {new Date(test.created_at).toLocaleString("tr-TR")}
          </p>
          <p>
            <strong>{t("DESCRIPTION", "Açıklama")}:</strong> {test.description}
          </p>

          {/* Yeni alanlar */}
          <p>
            <strong>{t("CATEGORY_TYPE", "Kategori Tipi")}:</strong> {categoryLabel}
          </p>
          <p>
            <strong>{t("HAS_SELECTION", "Seçim Olsun Mu? (İlk başta kategori seçtirecek miyiz?)")}:</strong>{" "}
            {test.has_selection
              ? t("YES", "Evet")
              : t("NO", "Hayır")}
          </p>
             <p>
            <strong>{t("IS_POPULER", "Popüler Test Olsun Mu?")}:</strong>{" "}
            {test.is_popular
              ? t("YES", "Evet")
              : t("NO", "Hayır")}
          </p>

                       <p>
            <strong>{t("IS_POPULER", "Anasayfada Görünsün mü?")}:</strong>{" "}
            {test.show_on_home
              ? t("YES", "Evet")
              : t("NO", "Hayır")}
          </p>
                                 <p>
            <strong>{t("IS_POPULER", "Öne Çıkan Kategori? (En çok puan alan kategorinin sonucuna göre)")}:</strong>{" "}
            {test.has_featured_category
              ? t("YES", "Evet")
              : t("NO", "Hayır")}
          </p>
                                         <p>
            <strong>{t("IS_POPULER", "İki Kategoriye Göre Sonuç Çıksın mı? (En çok puan alan iki kategorinin sonucuna göre)")}:</strong>{" "}
            {test.has_dual_category_result
              ? t("YES", "Evet")
              : t("NO", "Hayır")}
          </p>

                             <p>
           <strong>{t("PRICE", "Sayfadaki Soru Sayısı")}:</strong> {Number(test.question_counter)}
         </p>

                                          <p>
            <strong>{t("IS_POPULER", "Tamamen Ücretli Mi? (Ödeme yapıldıktan sonra test çözülebilir)")}:</strong>{" "}
            {test.is_fully_paid
              ? t("YES", "Evet")
              : t("NO", "Hayır")}
          </p>
          
                                          <p>
            <strong>{t("IS_POPULER", "İkili Ana Sonuç Sayfası Kullanılsın mı? (Ana editör, Yan editör)")}:</strong>{" "}
            {test.has_dual_main_result
              ? t("YES", "Evet")
              : t("NO", "Hayır")}
          </p>

          

                   <p>
           <strong>{t("PRICE", "Fiyat")}:</strong> {Number(test.price).toFixed(2)}
         </p>

          {test.image && (
            <div className="mt-3">
              <strong>{t("IMAGE", "Resim")}:</strong>
              <br />
              <img
                src={`${process.env.REACT_APP_API_BASE_URL}${test.image}`}
                alt="Test"
                className="img-fluid mt-2"
                style={{ maxHeight: 200 }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
